import { Injectable } from '@angular/core';
import { TableFiltersIndicator } from '@campaign-portal/components-library';
import { EntityField, InputType } from '@campaign-portal/namespace/common/entityField';
import { FilterType } from '@campaign-portal/namespace/common/rpc.params';

@Injectable({
	providedIn: 'root'
})
export class ManualDippingErrorsTableFieldsService {
	readonly headers: EntityField[] = [
		{
			id: 0,
			name: 'manual_dipping.dnis',
			variable: 'number',
			required: false,
			type: InputType.TEXT,
			filterType: FilterType.LIKE
		},
		{
			id: 1,
			name: 'manual_dipping.source',
			variable: 'sourceName',
			required: false,
			type: InputType.TEXT,
			filterType: FilterType.LIKE
		},
		{
			id: 2,
			name: 'manual_dipping.error',
			variable: 'errorMessage',
			required: false,
			type: InputType.TEXT,
			filterType: FilterType.LIKE
		},
		{
			id: 3,
			name: 'manual_dipping.log',
			variable: 'contextLog',
			required: false,
			type: InputType.TEXT,
			filterType: FilterType.LIKE
		}
	];
}

export const MDRESULTS_ERROR_TABLE_FILTERS: TableFiltersIndicator = new Map().set('number', {
	enabled: true,
	value: undefined,
	filterType: FilterType.LIKE
});
